import {
  visibilityIconSvg,
  visibilityOffIconSvg,
  closeModalIconSvg,
  utourZondaLogoSvg,
  nhsLogoSvg,
  checkIconSvg,
  utourArrowSvg,
  idCardSvg,
  creditCardSvg,
  jumioLogoSvg,
  stripeLogoSvg,
  progressCheckIconSvg,
  progressCurrentIconSvg,
  progressEmptyIconSvg,
} from "constants/svg-assets";

const parser = new DOMParser();

export const visibilityIconSvgElement = parser.parseFromString(
    visibilityIconSvg,
  'image/svg+xml'
).documentElement;

export const visibilityOffIconSvgElement = parser.parseFromString(
    visibilityOffIconSvg,
  'image/svg+xml'
).documentElement;

export const closeModalIconSvgElement = closeModalIconSvg;

export const utourZondaLogoSvgElement = utourZondaLogoSvg;

export const nhsLogoSvgElement = nhsLogoSvg;

export const checkIconSvgElement = checkIconSvg;

export const utourArrowSvgElement = utourArrowSvg;

export const idCardSvgElement = idCardSvg;

export const creditCardSvgElement = creditCardSvg;

export const jumioLogoSvgElement = jumioLogoSvg;

export const stripeLogoSvgElement = stripeLogoSvg;

export const progressCheckIconSvgElement = progressCheckIconSvg;

export const progressCurrentIconSvgElement = progressCurrentIconSvg;

export const progressEmptyIconSvgElement = progressEmptyIconSvg;
